const currentHref = window.location.href;
export default (currentHref.substring(currentHref.length - 3, currentHref.length) === '/fr' || currentHref.includes('/fr/') || process.env.VUE_APP_LOCALE === 'fr');
